<template>
    <div id="do"
         @click="hideKey">
        <template v-if="isLoading">
            <div class="header-wrap">
                <div class="header">
                    <i class="left"
                       :class="{'tea_enter':teaFlag}"
                       @click="back"></i>
                    <div class="theme">{{title}}</div>
                    <div v-if="is_tbcp"
                         @click="finishKwsl"
                         class="finish_btn">{{ status==1?"已完成":"完成" }}</div>
                </div>
            </div>
            <div :class="['con','active'+footerActive]"
                 v-if="detail">
                <div class="con_box"
                     ref="con_box">
                    <div :class="['section',{'has_pinyin':detail.show_pinyin==1},{'poetry':detail.article_type == 2}]"
                         v-for="s in detail.section"
                         :key="s.id"
                         v-html="s.content.replace(/\^v\^|&nbsp;/g,'')"></div>
                    <!-- 关键字 -->
                    <div v-show="isKeyword"
                         data="isControl"
                         ref="Keywords"
                         class="Keywords"
                         id="Keywords"
                         :style="{'left':`${toolX}px`,'top':`${toolY}px`}">
                        <template v-if="!footerActive">
                            <span data="isControl"
                                  v-for="(val, key, index) in explains"
                                  :key="`val${index}`"
                                  class="keywords_text"
                                  v-html="`${key}:${val}`"></span>
                        </template>
                        <template v-else>
                            <span data="isControl"
                                  class="keywords_text"
                                  v-for="(val, key, index) in explains"
                                  :key="`val${index}`"
                                  v-html="`${val}`"></span>
                        </template>
                    </div>
                    <i ref="KeywordDot"
                       v-show="isKeyword"
                       class="keyworddot"
                       :style="{'left':`${toolX + dotX>340?toolX + dotX-50:toolX + dotX}px`,'top':`${dotY}px`}"></i>
                </div>
            </div>
            <ul class="footer">
                <li :class="{'active':footerActive===t,'tea_enter':teaFlag}"
                    v-for="(text,t) in footerList"
                    :key="text"
                    @click="setFooterActive(t)">{{text}}</li>
            </ul>
        </template>
        <loading v-else></loading>
    </div>
</template>

<script >
import loading from 'SRC/components/base/tealoading.vue';
export default {
    data () {
        return {
            isLoading: false,
            id: this.$route.query.id,
            is_tbcp: this.$route.query.is_tbcp,
            status: this.$route.query.status,
            title: '',
            taskFlag: Number(this.$route.query.taskFlag) || 0, //1 学生做作业课文梳理
            footerList: ['字词', '句子', '段落'],
            footerActive: null,
            detail: null,
            paragraph_explains: [],
            sentence_explains: [],
            term_explains: [],
            explains: '',
            isKeyword: false,
            toolX: 0,
            toolY: 0,
            dotX: 0,
            dotY: 0,
            fontSize: null,
            teaFlag: Number(this.$route.query.teaFlag) || 0, //1 教师端进入
            activity: this.$route.query.activity || 0 //活动传参
        };
    },
    components: { loading },
    mounted () {
        let _html = document.getElementsByTagName('html')[0];
        this.fontSize = parseFloat(_html.style.fontSize);
    },
    methods: {
        back () {
            this.$router.go(-1);
        },
        finishKwsl () {
            if (this.status == 0) {
                let index = layer.open({ type: 2, shadeClose: false });
                this.$http.post(`${API_URL_HD_API}/summer2022/stu/yw/save_preview/`, {
                    type: 3,
                    paper_id: this.id
                }).then(res => {
                    this.submit = false;
                    res = res.data;
                    if (res.response === 'ok') {
                        this.status = 1;
                    }
                }).finally(() => {
                    layer.close(index)
                })
            }
        },
        setFooterActive (t) {
            this.isKeyword = false;
            this.footerActive = t;
            if (t === 0) {
                this.setMask('termNote', this.term_explains)
            } else if (t === 1) {
                this.setMask('sentenceNote', this.sentence_explains)
            } else if (t === 2) {
                this.setMask('paragraphNote', this.paragraph_explains)
            }
        },
        setMask (name, explains) {
            // 给“注”字添加点击后的浮层显示
            let nameNote = document.getElementsByClassName(name);
            for (let i = 0; i < nameNote.length; i++) {
                let element = nameNote[i];
                element.index = i
                element.addEventListener('touchstart', (event) => {
                    var eve = window.event || event;
                    var path = event.path || (event.composedPath && event.composedPath());
                    if (this.footerActive === 0 && name !== 'termNote' || this.footerActive === 1 && name !== 'sentenceNote' || this.footerActive === 2 && name !== 'paragraphNote') {
                        return false;
                    }
                    let flag = true,
                        ev = null;
                    if (event.target.className !== 'termNote' || event.target.className !== 'sentenceNote' || event.target.className !== 'paragraphNote') {
                        for (let i = 0; i < path.length; i++) {
                            if (this.footerActive === 0 && path[i].className === 'termNote' || this.footerActive === 1 && path[i].className === 'sentenceNote' || this.footerActive === 2 && path[i].className === 'paragraphNote') {
                                flag = false;
                                ev = path[i];
                                break;
                            }
                        }
                    }
                    // 填充内容
                    let _i;
                    if (flag) {
                        if (event.target.index == 0 || event.target.index) {
                            _i = event.target.index;
                        } else {
                            _i = event.target.offsetParent.index;
                        }
                    } else {
                        _i = ev.index;
                    }
                    this.explains = explains[_i];
                    // 显示当前
                    this.isKeyword = true;
                    if (event.cancelable) {
                        event.preventDefault();
                    }
                    this.$nextTick(() => {
                        let
                            Keyword = this.$refs.Keywords,//黑框
                            dot = this.$refs.KeywordDot,
                            con_box = this.$refs.con_box,

                            screen = window.screen.width,//屏幕宽度
                            _e = event.touches[0],//点击event

                            _width = Keyword.clientWidth,//黑框宽度
                            _height = Keyword.clientHeight,//黑框高度
                            _dwidth = dot.clientWidth,//箭头宽度
                            _dheight = dot.clientHeight,//箭头高度


                            rect = event.srcElement.getBoundingClientRect(),
                            left = _e.pageX,//用户点击X坐标
                            top = rect.left <= rect.right ? (_e.pageY - 10) : rect.top;
                        let scrollTop = con_box.scrollTop;
                        //如果黑框放到上边超出屏幕上方，则让其显示在点击位置的下方
                        if (top - _height - _dheight - this.fontSize * 2.4 - this.fontSize * 1 < 0) {
                            // 下方
                            this.toolY = rect.bottom + _dheight - this.fontSize * 2.4 - this.fontSize * 1 + scrollTop;
                            this.dotY = (-_dheight / 2) + this.toolY
                        } else {
                            // 上方
                            this.toolY = top - _height - _dheight - this.fontSize * 2.4 - this.fontSize * 1 + scrollTop;
                            this.dotY = (_height - _dheight / 2) + this.toolY;
                        }

                        let _left = left - _width / 2;
                        if (_left < 20) {
                            // 左侧超过屏幕，让其贴左
                            _left = 20;
                        } else if (_left + _width + 30 > screen) {
                            // 右侧超过屏幕,让其贴右
                            _left = screen - _width - 30;
                        }
                        this.toolX = _left - this.fontSize * 1 + 20
                        this.dotX = left - _left - this.fontSize * 1 > this.fontSize * 1 ? left - _left - this.fontSize * 1 + 20 : left - _left;
                    })
                }, false);
            }
        },
        hideKey (event) {
            var ev = window.event || event;
            var path = event.path || (event.composedPath && event.composedPath());
            if ((this.footerActive === 0 && event.target.className !== 'termNote' || this.footerActive === 1 && event.target.className !== 'sentenceNote' || this.footerActive === 2 && event.target.className !== 'paragraphNote') && event.target.className !== 'Keywords' && event.target.className !== 'keywords_text') {
                let flag = true;
                for (let i = 0; i < path.length; i++) {
                    if (path[i].className === 'termNote' || path[i].className === 'sentenceNote' || path[i].className === 'paragraphNote') {
                        flag = false;
                        break;
                    }
                }
                if (flag) {
                    this.isKeyword = false;
                }
            }
        }
    },
    created () {
        let data = {}, url = "";
        if (this.is_tbcp) {
            data = { paper_id: this.id };
            url = API_URL_HD_API + '/summer2022/stu/yw/preview_content/';
        } else if (this.activity == '2022winter') {
            data = { paper_id: this.id };
            url = API_URL_HD_API + '/winter2022/stu/preview_content/';
        } else if (this.activity == '2023winter'||this.activity == '2024winter') {
            data = { paper_id: this.id };
            url = API_URL_HD_API + '/winter2023/stu/preview_content/';
        } else {
            data = { aid: this.id };
            url = API_URL_QNYD_API + '/inner_reading/article/get_article_detail_by_aid';
        }
        this.$http.post(url, data).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.detail = res.data;
                this.paragraph_explains = this.detail.paragraph_explains;
                this.sentence_explains = this.detail.sentence_explains;
                this.term_explains = this.detail.term_explains;
                this.title = this.detail.title;
                this.isLoading = true;
            }
        })
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
#do {
    .con {
        .section {
            p {
                display: inline;
            }
            &.poetry {
                p {
                    display: block;
                }
            }
            ruby {
                position: relative;
                top: 2px;
            }
            rt {
                user-select: none;
                width: 3em;
                white-space: nowrap;
                text-align: center;
            }
        }
    }
    .active0 .termNote,
    .active1 .sentenceNote,
    .active2 .paragraphNote {
        position: relative;
        font-size: 36px / $ppr;
        color: #ff7256;
        &:after {
            content: "";
            display: inline-block;
            width: 44px / $ppr;
            height: 44px / $ppr;
            border-radius: 50%;
            color: #fff;
            font-size: 22px / $ppr;
            text-align: center;
            margin: 0 24px / $ppr 0 10px / $ppr;
            line-height: 44px / $ppr;
            vertical-align: middle;
            margin-top: -8px / $ppr;
            background-image: url("./img/icon_tips.png");
            background-size: 100% 100%;
        }
    }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
#do {
    min-height: 100vh;
    background: #f4f4f4;
    .header {
        background-color: #ffffff;
        font-size: 36px / $ppr;
        color: #333333;
        .left {
            width: 36px / $ppr;
            height: 30px / $ppr;
            background: url("./img/icon_img_2.png") 0 0 no-repeat;
            background-size: 100% 100%;
            &.tea_enter {
                background-image: url("./img/icon_img_8.png");
            }
        }
        .finish_btn {
            width: 122px / $ppr;
            height: 56px / $ppr;
            line-height: 56px / $ppr;
            color: #fff;
            font-size: 24px / $ppr;
            text-align: center;
            border-radius: 28px / $ppr;
            background-color: #5dd6ff;
            position: absolute;
            top: 20px / $ppr;
            right: 24px / $ppr;
            cursor: pointer;
        }
    }
    .con {
        padding: 40px / $ppr 0;
        height: calc(100vh - 2.4rem - 3.35rem);
        overflow: hidden;
        box-sizing: border-box;
        .con_box {
            position: relative;
            height: 100%;
            overflow-y: auto;
            word-break: break-all;
            padding: 0 48px / $ppr;
        }
        .section {
            font-size: 34px / $ppr;
            text-indent: 2em;
            line-height: 1.75;
            color: #333333;
            &.has_pinyin {
                line-height: 2.75;
            }
            &.poetry {
                text-align: center;
                text-indent: 0;
            }
        }
    }
    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100vw;
        height: 134px / $ppr;
        line-height: 134px / $ppr;
        text-align: center;
        background: #ffffff;
        z-index: 2;
        border-radius: 30px / $ppr 30px / $ppr 0 0;
        li {
            display: inline-block;
            margin-left: 32px / $ppr;
            width: 180px / $ppr;
            height: 64px / $ppr;
            line-height: 64px / $ppr;
            border: 2px / $ppr solid #37cdff;
            font-size: 30px / $ppr;
            color: #37cdff;
            border-radius: 64px / $ppr;
            box-sizing: border-box;
            &.tea_enter {
                border-color: #5e89ef;
                color: #5e89ef;
                &.active {
                    background: #5e89ef;
                }
            }
            &:first-child {
                margin-left: 0;
            }
            &.active {
                background: #37cdff;
                color: #ffffff;
            }
        }
    }
    // 关键字
    .keywords_text::-webkit-scrollbar {
        display: none;
    }
    #Keywords {
        width: 468px / $ppr;
        height: 230px / $ppr;
        position: absolute;
        z-index: 100;
        overflow: auto;
        padding: 20px / $ppr;
        background: #333333;
        border-radius: 8px / $ppr;
        color: #fff;
        font-size: 30px / $ppr;
        word-wrap: break-word;
        transition: all 0.2s linear;
        box-sizing: border-box;
    }
    .keywords_text {
        display: block;
        height: 190px / $ppr;
        overflow-y: auto;
    }
    .keyworddot {
        display: block;
        z-index: 10;
        position: absolute;
        height: 20px / $ppr;
        width: 20px / $ppr;
        background-color: #333333;
        transform: rotate(45deg);
        transition: all 0.2s linear;
    }
}
</style>
